// import api from './index'

// const mock = (url) => { // 接口调用mock数据
//   console.log('mock: ' + url)
//   return new Promise(function (resolve, reject) {
//     let response = require(`../mock/${url}`)
//     resolve(response.data)
//   })
// }

const apis = {
}

export default {
  apis
}



// WEBPACK FOOTER //
// ./src/api/apis.js